import { Action, AnyAction } from 'redux';
import { ThunkDispatch, ThunkAction } from 'redux-thunk';
import Cookie from 'js-cookie';
import { API_EC, API_KEN } from 'config/host';
import { get, post, resolve } from 'libs/request';
import urlParams from 'libs/query';
import apiWrapper, { apiActionWrapper, ActionGen } from 'actions/api';
import { differMultiCampaign } from 'services/campaign/differ-multi-campaign';
import toast from 'components/common/toast';
import { ICampaign } from 'types/campaign';
import { ApiError } from 'types/api-error';
import {
    prefetchGetBuyNow,
    prefetchGetOrderInfoAction,
    prefetchGetProductDetail
} from './prefetch-action';
import { IPostFeesApiData } from '../../cart/store/form-reducer';

import { GET_COUPON_LIST } from 'components/coupon/reducer';
import { GET_DEFAULT_ADDRESS, getDefaultAddress } from 'components/address/reducer';
import bridge from '@byted/ecom-mobile-lib/lib/bridge';
import { numberWrapper } from 'src/services/goods/update-num';
import { getFeightByAddress } from './send-legalcode-middleware';
import { isZeroOrNul, greaterZero } from 'src/utils/common-func';

export const MODIFY_LOADING_STATUS = 'MODIFY_LOADING_STATUS';
const MODIFY_FAILURE = 'MODIFY_FAILURE';
export const BASEINFO_LOADED = 'BASEINFO_LOADED';
export const MODIFY_GOODS_NUM = 'MODIFY_GOODS_NUM';
const SERVICEINFO_LOADED = 'SERVICEINFO_LOADED';
const MODIFY_BUYER_WORDS = 'MODIFY_BUYER_WORDS';
export const SHOW_PAY_FORM = 'SHOW_PAY_FORMS';
const SET_VIRTUAL = 'SET_VIRTUAL';
const SET_MOBILE_ERROR = 'SET_MOBILE_ERROR';
const TOGGLE_RET_INS_DIALOG = 'TOGGLE_RET_INS_DIALOG';
const TOGGLE_SUPPORT_RET_INS = 'TOGGLE_SUPPORT_RET_INS';
const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
const ABINFO_LOADED = 'ABINFO_LOADED';
export const SET_REMAIN_DIALOG = 'SET_REMAIN_DIALOG';
const GET_MARQUEE = {
    SUCCESS: 'GET_MARQUEE_SUCCESS',
    FAILURE: 'GET_MARQUEE_FAILURE',
    REQUEST: 'GET_MARQUEE_REQUEST'
};
const GET_FREIGHT = {
    SUCCESS: 'GET_FREIGHT_SUCCESS',
    FAILURE: 'GET_FREIGHT_FAILURE',
    REQUEST: 'GET_FREIGHT_REQUEST'
};
export const SET_FREIGHT = 'SET_FREIGHT';

interface ModifyLoadingStatusAction {
    type: typeof MODIFY_LOADING_STATUS;
    payload: boolean;
}

interface ModifyFailureAction {
    type: typeof MODIFY_FAILURE;
    payload: ApiError;
}

interface BaseInfoLoadedAction {
    type: typeof BASEINFO_LOADED;
    payload: any;
}
interface RetInsDialogChangeAction {
    type: typeof TOGGLE_RET_INS_DIALOG;
    payload: { retInsDialogShow: boolean; retInsDialogContent: string };
}
interface SupportRetInsChangeAction {
    type: typeof TOGGLE_SUPPORT_RET_INS;
    payload: boolean;
}

interface AbinfoLoadedAction {
    type: typeof ABINFO_LOADED;
    payload: any;
}

interface ModifyGoodsNumAction {
    type: typeof MODIFY_GOODS_NUM;
    payload: number;
}

interface ModifyBuyerWordsAction {
    type: typeof MODIFY_BUYER_WORDS;
    payload: string;
}

interface ServiceInfoLoadedAction {
    type: typeof SERVICEINFO_LOADED;
    payload: ServiceInfo;
}

interface ShowPayFormAction {
    type: typeof SHOW_PAY_FORM;
    payload: boolean;
}

interface SetVirtualAction {
    type: typeof SET_VIRTUAL;
    payload: Virtual;
}

interface SetMobileErrorAction {
    type: typeof SET_MOBILE_ERROR;
    payload: boolean;
}

interface SetLoginStatusAction {
    type: typeof SET_LOGIN_STATUS;
    payload: boolean;
}

type ActionTypes =
    | ModifyLoadingStatusAction
    | ModifyFailureAction
    | BaseInfoLoadedAction
    | ModifyGoodsNumAction
    | ServiceInfoLoadedAction
    | ModifyBuyerWordsAction
    | ShowPayFormAction
    | SetVirtualAction
    | SetMobileErrorAction
    | SetLoginStatusAction
    | AbinfoLoadedAction
    | RetInsDialogChangeAction
    | SupportRetInsChangeAction
    | AnyAction;

export interface Spec {
    name: string;
    value: string;
}
export interface GoodsInfo {
    title: string;
    img: string;
    specs: Spec[];
    price: number;
    status: number;
    payType: number;
    shopName: string;
    stock: number;
    weight: number;
    userLimit: number;
    skuId: string;
    shopId: string;
    supplyStatus: number;
    freight: any;
    endTime: number;
    skuLimit: number;
    productType: number; // 以后会不新增了
    cidLimit: number;
    productPlatform: string;
    needLogistic: boolean; // 是否需要物流
    needCheckout: boolean; // 是否需要核销
    logo: string;
}

export enum SupportReturn {
    No = 0,
    Yes = 1,
    Partial = 2
}

export interface Virtual {
    mobile?: string;
    addressId?: string;
    error?: boolean;
}

export interface ServiceInfo {
    remainWords?: string;
    presellType?: number;
    presellEndTime?: number;
    presellDelay?: number;
    delayDay?: number;
    supportReturn: SupportReturn;
    quickRefund?: boolean;
    loaded: boolean;
    deliveryText?: string;
    userBuyLimit: number;
    influencerInfo: {
        name: string; // 推荐人名称
        userId: string;
        secUserId: string;
    };
    // 参与活动的 Icon
    activity: {
        tag_icon_uri: string;
        // 活动打标图标
        tag_icon_url: string;
        // 活动打标图标地址
        campaign_id: string;
        // 平台活动 ID
        campaign_type: string;
    } | null;
    supportRetIns?: boolean; // 是否支持退货运费险 实物
}

export interface MarqueeItem {
    content: string;
    avatar: string;
}

interface MarqueeInfo {
    showMarquee: boolean;
    list: MarqueeItem[];
}

interface AbInfoType {
    quickRefundType?: number;
    abLoaded: boolean;
    abType?: number;
    hidePayRecommend?: boolean;
    hideLowStock?: boolean;
    hideFastRefund?: boolean;
    useOldReturnTag?: boolean;
}
export interface BaseState {
    loading: boolean;
    failure?: ApiError;
    num: number;
    buyerWords: string;
    campaign: ICampaign;
    fullDiscount?: ICampaign;
    goods?: GoodsInfo;
    service: ServiceInfo;
    showPayForm: boolean;
    virtual?: Virtual;
    islogin?: boolean;
    payFormType?: string;
    remainWords?: string;
    showRemainDialog?: boolean;
    flatAddress: boolean;
    abInfo: AbInfoType;
    remain?: boolean;
    marquee?: MarqueeInfo;
    freightAmount: undefined | number;
    isLimit: boolean;
    retInsDialogShow: boolean; //  退货运费险 dialog
    retInsDialogContent: string;
}
// 切换是否支持退货运费险
export function toggleSupportRetIns(support: boolean) {
    return {
        type: TOGGLE_SUPPORT_RET_INS,
        payload: support
    };
}
// 切换退货运费险 弹窗展示
export function toggleRetInsDialog(dialogInfo: {
    retInsDialogShow: boolean;
    retInsDialogContent: string;
}) {
    return {
        type: TOGGLE_RET_INS_DIALOG,
        payload: dialogInfo
    };
}

export function modifyGoodsNum(num: number) {
    return {
        type: MODIFY_GOODS_NUM,
        payload: num
    };
}

export function modifyBuyerWords(words: string) {
    return {
        type: MODIFY_BUYER_WORDS,
        payload: words
    };
}

export function setVirtual(mobile: Virtual) {
    return {
        type: SET_VIRTUAL,
        payload: mobile
    };
}

export const setMobileError = (error: boolean) => {
    return {
        type: SET_MOBILE_ERROR,
        payload: error
    };
};

export const setLoginStatus = (status: boolean) => {
    return {
        type: SET_LOGIN_STATUS,
        payload: status
    };
};
// 不需要物流的商品提单页走虚拟商品流程
export const isVirtualGetter = (state: { base: BaseState }) =>
    !!state.base.goods &&
    (state.base.goods.needLogistic === false || state.base.goods.productType === 3);

export const payFormTypeGetter = (state: { base: BaseState }) => state.base.payFormType;

export const getFreight = (data: IPostFeesApiData) => {
    return apiActionWrapper(
        GET_FREIGHT,
        post(`${API_EC}/cart/postFees`, JSON.stringify(data), {
            headers: { 'Content-Type': 'application/json' }
        }),
        false
    );
};

const DEFAULT_MAX_BUY_NUM = 200;
const initalState: BaseState = {
    loading: true,
    buyerWords: '',
    showPayForm: false,
    num: greaterZero(urlParams.combo_num),
    flatAddress: false,
    payFormType: 'flat',
    remain: true,
    abInfo: {
        abLoaded: false
    },
    freightAmount: undefined,
    isLimit: false,
    service: {
        loaded: false,
        userBuyLimit: DEFAULT_MAX_BUY_NUM,
        supportRetIns: false // 是否支持退货运费险
    },
    retInsDialogShow: false,
    retInsDialogContent: '' // 运费险 dialog content
};
// eslint-disable-next-line complexity
export default function baseReducer(
    state: BaseState = initalState,
    action: ActionTypes
): BaseState {
    switch (action.type) {
        case MODIFY_FAILURE:
            return { ...state, failure: action.payload, loading: false };
        case MODIFY_LOADING_STATUS:
            return { ...state, loading: action.payload, failure: undefined };
        case BASEINFO_LOADED: {
            const differCampaign = differMultiCampaign(action.payload.campaign_info);
            return {
                ...state,
                goods: extractGoodsInfo(action.payload),
                service: { ...state.service, ...extractServiceInfo(action.payload) },
                campaign: differCampaign.campaign,
                fullDiscount: differCampaign.fullDiscount,
                loading: false,
                virtual: {
                    mobile: action.payload.tel || '',
                    addressId: action.payload.address_id,
                    error: !action.payload.tel
                }
            };
        }
        case TOGGLE_SUPPORT_RET_INS:
            return { ...state, service: { ...state.service, supportRetIns: action.payload } };
        case TOGGLE_RET_INS_DIALOG:
            return {
                ...state,
                retInsDialogShow: action.payload.retInsDialogShow,
                retInsDialogContent: action.payload.retInsDialogContent
            };
        case MODIFY_GOODS_NUM:
            return { ...state, num: action.payload };
        case SERVICEINFO_LOADED:
            return {
                ...state,
                remainWords: action.payload.remainWords,
                service: { ...state.service, ...action.payload }
            };
        case MODIFY_BUYER_WORDS:
            return { ...state, buyerWords: action.payload };
        case SHOW_PAY_FORM:
            return { ...state, showPayForm: action.payload };
        case SET_VIRTUAL:
            return { ...state, virtual: { ...state.virtual, ...action.payload } };
        case SET_MOBILE_ERROR:
            return { ...state, virtual: { ...state.virtual, error: action.payload } };
        case SET_LOGIN_STATUS:
            return { ...state, islogin: action.payload };
        case GET_COUPON_LIST.FAILURE:
            if (action.payload.code === 401) {
                return { ...state, islogin: false };
            }
            return state;
        case ABINFO_LOADED:
            return {
                ...state,
                abInfo: {
                    abLoaded: true
                }
            };
        case SET_REMAIN_DIALOG:
            return {
                ...state,
                showRemainDialog: action.payload
            };
        case GET_MARQUEE.SUCCESS:
            return {
                ...state,
                marquee: action.payload
            };
        case GET_FREIGHT.SUCCESS:
            return {
                ...state,
                freightAmount: Number(action.payload.post_amount),
                isLimit: action.payload.restricted.length !== 0
            };
        case SET_FREIGHT:
            return { ...state, freightAmount: action.payload };
        default:
            return state;
    }
}

const extractGoodsInfo = (orderInfo: any): GoodsInfo => {
    const skuInfo = orderInfo.order_stock || {};
    if (!skuInfo.price) throw new Error('价格异常');

    return {
        img: (skuInfo.pic && `https://p3a.pstatp.com/large/${skuInfo.pic}`) || orderInfo.img,
        title: orderInfo.name || '',
        specs: skuInfo.order_spec || [],
        price: numberWrapper(skuInfo.price),
        status: orderInfo.status,
        payType: orderInfo.pay_type,
        shopName: orderInfo.shop_name || '',
        stock: numberWrapper(skuInfo.stock_num),
        weight: orderInfo.weight || '0',
        userLimit: numberWrapper(orderInfo.user_limit),
        skuId: skuInfo.id || urlParams.combo_id,
        skuLimit: numberWrapper(skuInfo.user_limit),
        shopId: orderInfo.shop_id,
        supplyStatus: orderInfo.supply_status,
        freight: orderInfo.freight,
        endTime: orderInfo.end_time,
        productType: orderInfo.product_type,
        cidLimit: orderInfo.cid_limit || Number.MAX_SAFE_INTEGER,
        productPlatform: orderInfo.product_platform,
        needLogistic: orderInfo.need_logistic,
        needCheckout: orderInfo.need_checkout,
        logo: orderInfo.shop_logo || '',
        warehouseId: skuInfo.warehouse_id,
        reduceType: orderInfo.reduce_type,
        skuType: skuInfo.sku_type
    };
};

const extractServiceInfo = (orderInfo: any) => {
    return {
        presellType: orderInfo.presell_type,
        presellEndTime: orderInfo.presell_end_time,
        presellDelay: orderInfo.presell_delay
    };
};

export const getAbtestInfo: () => ThunkAction<void, any, undefined, Action> = () => (
    dispatch: ThunkDispatch<any, undefined, Action>
) => {
    dispatch(
        apiWrapper(
            'GET_ABTEST_INFO_REQUEST',
            'GET_ABTEST_INFO_FAILURE',
            ABINFO_LOADED,
            get(`${API_EC}/index/getNewAbUiParams?token=aweme&key=douyin`)
        )
    );
};

// toast 提示
const showToast = (payload, address, isLimit, disableToast) => {
    if (
        (!payload.order_stock.stock_num || payload.order_stock.stock_num === '0') &&
        Number(payload.reduce_type) === 1 &&
        !(
            Number(payload.order_stock.sku_type) === 1 &&
            isZeroOrNul(payload.order_stock.warehouse_id)
        ) &&
        !isLimit
    ) {
        !disableToast &&
            setTimeout(() => {
                toast(
                    `${
                        payload.order_stock.warehouse_id ? address.area : ''
                    }商品已拍完，但还有人未支付，待会儿刷新试试`
                );
            }, 100);
    }
};

// action 触发
const fetchDowngrade: (
    dispath: ThunkDispatch<any, undefined, Action>,
    ...callbackArr: Array<(...args: any) => any>
) => void = (dispath, ...callbackArr) => {
    callbackArr.forEach((cb) => {
        typeof cb === 'function' && dispath(cb);
    });
};

// action 触发
const actionAssignment: ActionGen<any, any> = (base) => ({ address, product }) => (dispatch) => {
    const { campaign } = differMultiCampaign(product.campaign_info);
    [
        {
            type: BASEINFO_LOADED,
            payload: product
        },
        {
            type: GET_DEFAULT_ADDRESS.SUCCESS,
            payload: address
        },
        getFeightByAddress(address, base.num, campaign && campaign.campaign_id)
    ].forEach((item) => dispatch(item));
    showToast(product, address, base.isLimit);
};

// 获取订单信息
export const getOrderInfo = (params: any = {}, disableToast) => {
    const { prov_id: addr_id1, city_id: addr_id2, area_id: addr_id3 } = params;
    return apiWrapper(
        MODIFY_LOADING_STATUS,
        MODIFY_FAILURE,
        (payload) => (dispatch) => {
            dispatch({
                type: BASEINFO_LOADED,
                payload
            });
            showToast(payload, params, params.isLimit, disableToast);
        },
        prefetchGetOrderInfoAction({
            productId: urlParams.product_id || urlParams.id,
            skuId: urlParams.combo_id,
            originType: urlParams.origin_type,
            pageId: urlParams.page_id,
            ...{ addr_id1, addr_id2, addr_id3 }
        })
    );
};

export const requestBaseInfo: () => ThunkAction<void, any, undefined, Action> = () => (
    dispatch: ThunkDispatch<any, undefined, Action>,
    getState
) => {
    const page_id = urlParams.page_id;
    const productId = urlParams.product_id || urlParams.id;
    const skuId = urlParams.combo_id;
    if (!productId || !skuId) {
        return dispatch({
            type: MODIFY_FAILURE,
            payload: {
                code: 10001,
                message: '参数缺失'
            }
        });
    }

    /**
     * 提单页库存需求
     * @author yus
     * @date: 2020.07.20
     */
    dispatch((...args) => {
        apiWrapper(
            MODIFY_LOADING_STATUS,
            MODIFY_FAILURE,
            actionAssignment(getState().base),
            prefetchGetBuyNow({
                productId,
                skuId: urlParams.combo_id,
                originType: urlParams.origin_type,
                pageId: page_id
            }),
            true
        )(...args).catch(async (_) => {
            try {
                await dispatch(getDefaultAddress());
                dispatch(
                    getOrderInfo({
                        ...getState().address.selected,
                        isLimit: getState().base.isLimit
                    })
                );
                // 只有运费数据有问题才需要开启
                getFeightByAddress(
                    getState().address.selected,
                    getState().base.num,
                    getState().base.campaign && getState().base.campaign.campaign_id
                );
            } catch (err) {
                dispatch(getOrderInfo());
            }
        });
    });

    dispatch((dispatch) =>
        prefetchGetProductDetail({
            id: productId,
            originId: urlParams.origin_id,
            originType: urlParams.origin_type
        })
            .then(resolve)
            .then((result) => {
                const { grayToken } = result;
                if (grayToken) {
                    Cookie.set('ecom_gray_11', grayToken, {
                        expires: 7
                    });
                }
                return dispatch({
                    type: SERVICEINFO_LOADED,
                    payload: {
                        loaded: true,
                        delayDay: parseInt(result.delay_day, 0),
                        supportReturn: parseInt(result.support_return_type, 0),
                        remainWords: result.remain_words,
                        quickRefund: result.quickRefund,
                        userBuyLimit: result.user_buy_limit,
                        ...result
                    }
                });
            })
    );
};
declare global {
    interface Window {
        __ECOM_GLOBAL_CONFIG?: any;
    }
}

export const getMarqueeContent: (productId: string) => ThunkAction<void, any, undefined, Action> = (
    productId
) => (dispatch: ThunkDispatch<any, undefined, Action>) => {
    if (!productId) return;

    bridge
        .call('appInfo', {}, { timeout: 500 })
        .then(
            (info: any) => (info && info.aid ? (info.aid as number) : 1128),
            () => 1128
        )
        .then((aid: number) => {
            dispatch(
                apiActionWrapper(
                    GET_MARQUEE,
                    get(`${API_KEN}/product/getMarqueeContent?product_id=${productId}&aid=${aid}`)
                )
            );
        });
};
